module.exports = __webpack_public_path__ + "static/media/splash_background@3x.a63bf919.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/splash_background@3x.png
// module id = 636
// module chunks = 0